import { CommonModule } from '@angular/common';
import { Component, OnInit, OnDestroy, ViewChild, ChangeDetectorRef } from '@angular/core';
import { SidebarModule } from 'primeng/sidebar';
import { CaseDetailsService } from '../../../components/home/case-details/case-details.service';
import { interval, Subscription } from 'rxjs';
import Swal from 'sweetalert2';
import { SharedService } from '../../services/shared.service';

interface Notification {
  title: string;
  message: string;
  date: string;
}

interface Notifications {
  today: Notification[];
  yesterday: Notification[];
  byDate: { [key: string]: Notification[] };
}


@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss'],
  standalone: true,
  imports: [SidebarModule, CommonModule]
})
export class NotificationsComponent implements OnInit, OnDestroy {

  sidebarVisible: boolean = false;
  selectedTab: string = 'all';
  private notificationCountSubscription!: Subscription;
  private notificationCount: number = 0;
  private previousNotificationCount: number = 0;
  notificationDifference: number = 0;
  // notifications: Notifications = { today: [], yesterday: [], byDate: {} };
  notifications: any = [];
  entityId: string = 'ABG';
  backupNotifications: any[] = [];
  loading: boolean = false;
  toInAppId: string = 'ADMIN';
  constructor(
    private caseDetailsService: CaseDetailsService,
    private cdr: ChangeDetectorRef,
    private sharedService: SharedService
  ) { }

  ngOnInit(): void {
    this.toInAppId=this.sharedService.userId;
    const storedCount = localStorage.getItem('previousNotificationCount');
    this.previousNotificationCount = storedCount ? parseInt(storedCount, 10) : 0;
    this.notificationCountSubscription = interval(10000).subscribe(() => this.getNotificationCount());
  }

  ngOnDestroy(): void {
    if (this.notificationCountSubscription) {
      this.notificationCountSubscription.unsubscribe();
    }
  }
  showNotification() {
    this.sidebarVisible = true
    this.getNotificationList('all');
    this.selectedTab = 'all';
    this.previousNotificationCount = this.notificationCount;
    localStorage.setItem('previousNotificationCount', this.previousNotificationCount.toString());
  }


  getNotificationList(tab: string) {
    const payload: any = {
      "enityId": this.entityId,
      "notificationChannels": ["IN_APP"],
      "toEmailId": [],
      "toInAppId": [this.toInAppId],
      "status": tab == 'all' ? null : tab.toUpperCase()
    };
    this.caseDetailsService.getNotifications(payload).subscribe((res: any) => {
      this.backupNotifications = res.data;
      this.notifications = res.data;
      // const notifications = res.data;
      // this.getNotificationsBasedOnDate(notifications);
    });
  }
  deleteAll() {
    // Swal.fire({
    //   title: 'Are you sure?',
    //   text: 'You want to delete all notifications!',
    //   icon: 'warning',
    //   showCancelButton: true,
    //   confirmButtonColor: '#3085d6',
    //   cancelButtonColor: '#d33',
    //   confirmButtonText: 'Yes, delete all!'
    // }).then((result) => {
    //   if (result.isConfirmed) {
    //     console.log('deleteAll');
    //   }
    // });
    this.deleteAllNotifications();

  }

  markAllAsRead() {
    // Swal.fire({
    //   title: 'Are you sure?',
    //   text: 'You want to mark all as read!',
    //   icon: 'warning',
    //   showCancelButton: true,
    //   confirmButtonColor: '#3085d6',
    //   cancelButtonColor: '#d33',
    //   confirmButtonText: 'Yes, mark all as read!'
    // }).then((result) => {
    //   if (result.isConfirmed) {
    //     console.log('markAllAsRead');
    //   }
    // });
    this.loading = true;

    const payload: any = {
      "enityId": this.entityId,
      "fromStatus": "ACKNOWLEDGED",
      "toStatus": "READ",
      "toInAppId": this.toInAppId
    };
    setTimeout(() => {
      this.caseDetailsService.updateAllNotifications(payload).subscribe((res: any) => {
        this.loading = false;
        this.notifications = this.notifications.map((notification: any) => {
          if (notification.status === payload.fromStatus) {
            return { ...notification, status: payload.toStatus };
          }
          return notification;
        });
        this.backupNotifications = this.backupNotifications.map((notification: any) => {
          if (notification.status === payload.fromStatus) {
            return { ...notification, status: payload.toStatus };
          }
          return notification;
        });
      },
        (error: any) => {
          this.loading = false;
        }
      );
    }, 500);
  }
  getNotificationCount() {
    const payload: any = {
      "enityId": this.entityId,
      "toInAppId": this.toInAppId
    };
    this.caseDetailsService.getNotificationCount(payload).subscribe((res: any) => {
      if (this.previousNotificationCount > 0) {
        this.notificationDifference = res.data?.count - this.previousNotificationCount;
        if(this.notificationDifference < 0) {
          this.notificationDifference = 0;
        }
      }

      console.log('Notification Difference:', this.notificationDifference);
      this.notificationCount = res.data?.count;
    });
  }

  switchTab(tab: string) {
    this.loading = true; // Start loading
    this.selectedTab = tab;
    setTimeout(() => {
      var filteredNotifications: any[] = this.backupNotifications;
      if (tab != 'all') {
        filteredNotifications = filteredNotifications.filter((notification: any) =>
          notification?.status === (tab === "read" ? "READ" : "ACKNOWLEDGED")
        );
      }
      this.notifications = filteredNotifications;
      console.log('Filtered Notifications:', filteredNotifications);
      this.loading = false; 
    }, 500); 
  }

  updateNotification(ids: number, status: string) {
    const payload: any = {
      "enityId": this.entityId,
      "inAppNotificationIds": [ids],
      "status": status
    };
    console.log('Payload:', payload);
    this.caseDetailsService.updateNotification(payload).subscribe((res: any) => {
      // this.notificationDifference = res.data - this.previousNotificationCount;
      // this.previousNotificationCount = res.data;
 
      this.notifications = this.notifications.filter((notification: any) => notification.notificationId !== ids);
    
      if (status === 'DELETE') {
        this.backupNotifications = this.backupNotifications.filter((notification: any) => notification.notificationId !== ids);
        const storedCount = localStorage.getItem('previousNotificationCount');
        this.previousNotificationCount = storedCount ? parseInt(storedCount, 10) : 0 - 1;
        localStorage.setItem('previousNotificationCount', this.previousNotificationCount.toString());

      }else{
        this.backupNotifications = this.backupNotifications.map((notification: any) => {
          if (notification.notificationId === ids) {
            return { ...notification, status: status };
          }
          return notification;
        });
      }
      // this.notificationCount = res.data;
    });
  }

  deleteAllNotifications() {
    this.loading = true;
    var selectedStaus: string | null = '';
    if (this.selectedTab == 'unread') {
      selectedStaus = 'ACKNOWLEDGED';
    }
    else if (this.selectedTab == 'read') {
      selectedStaus = 'READ';
    }
    else {
      selectedStaus = null;
    }
    const payload: any = {
      "enityId": this.entityId,
      "fromStatus": selectedStaus,
      "toStatus": "DELETE",
      "toInAppId": this.toInAppId
    };
    setTimeout(() => {
      this.caseDetailsService.updateAllNotifications(payload).subscribe((res: any) => {
        this.loading = false;
        if (selectedStaus != null) {
          this.notifications = this.notifications.filter((notification: any) => notification.status !== selectedStaus);
          this.backupNotifications = this.backupNotifications.filter((notification: any) => notification.status !== selectedStaus);
        } else {
          this.notifications = [];
          this.backupNotifications = [];
        }
      },
        (error: any) => {
          this.loading = false;
        });
    }, 500);
  }
}
